import { render, staticRenderFns } from "./patientList.vue?vue&type=template&id=f10ec81e&scoped=true"
import script from "./patientList.vue?vue&type=script&lang=js"
export * from "./patientList.vue?vue&type=script&lang=js"
import style0 from "./patientList.vue?vue&type=style&index=0&id=f10ec81e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10ec81e",
  null
  
)

export default component.exports